import { Component, inject } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';

import { RightSidebarService } from './right-sidebar.service';

@Component({
  selector: 'app-right-sidebar',
  templateUrl: './right-sidebar.component.html',
  standalone: true,
  imports: [RouterOutlet]
})
export class RightSidebarComponent {
  private activationEvent: any;
  protected router = inject(Router);
  protected rightSidebarService = inject(RightSidebarService);

  onRouteActivated(evt) {
    this.rightSidebarService.toggleRightSidebar(true);
    this.activationEvent = evt;
  }

  onRouteDeactivated() {
    this.activationEvent = undefined;
    setTimeout(() => {
      if (!this.activationEvent) this.rightSidebarService.toggleRightSidebar(false);
    }, 100);
  }
}
